// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__6LHUM","buttons":"Footer_buttons__2GWpC"};